import { Brand } from '../../apis/graphql/types';

export const brand: Brand = {
  address: {
    city: 'New York',
    country: 'USA',
    line1: '112 Cherry Street',
    line2: '',
    state: 'NY',
    zipCode: '10001',
  },
  createdAt: '09/10/2024',
  id: 'brand-id-1',
  industry: {
    name: 'Cars and Trucks',
    id: 'industry-id-1',
  },
  name: 'Red Chevrolet',
  status: 'ACTIVE',
};
